import { useChatContext } from '@almai1/chatbot-widget'
import { useTranslation } from 'react-i18next'

// Chat bubble icon for empty state
function ChatBubbleIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      <path d="M8 9h8M8 13h4"/>
    </svg>
  )
}

export function EmptyState() {
  const { t } = useTranslation()
  const { sendMessage } = useChatContext()

  const starters = [
    t('widget.starterOrganize'),
    t('widget.starterExperiences'),
    t('widget.starterQuestions'),
    t('widget.starterUnsure'),
  ]

  return (
    <div className="widget-empty-state">
      <div className="widget-empty-icon">
        <ChatBubbleIcon />
      </div>
      <h3>{t('widget.welcomeTitle')}</h3>
      <p>{t('widget.welcomeMessage')}</p>
      <div className="widget-starter-buttons">
        {starters.map((label) => (
          <button
            key={label}
            type="button"
            className="widget-starter-button"
            onClick={() => sendMessage(label)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}
